// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CommonText-module--wrapper--2W7_m","title":"CommonText-module--title--2y-JY","requirements":"CommonText-module--requirements--1boVe"};